var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 0"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.options.items), function(item, index) {
    return (!item.vif || item.vif(_vm.query)) ? _c('div', {
      key: index,
      staticStyle: {
        "margin-right": "10px",
        "margin-bottom": "10px"
      }
    }, [(item.type == 'selection') ? _c('Select', {
      style: (("width:" + (item.width || 240) + "px")),
      attrs: {
        "value": item.multi ? ((_vm.query[item.key] && _vm.query[item.key].length) ? _vm.query[item.key].map(function (i) {
          return item.render(i)
        }) : []) : item.render(_vm.query[item.key]),
        "multiple": item.multi || false,
        "filterable": item.filterable || false,
        "clearable": item.clearable || false,
        "max-tag-count": item['max-tag-count'],
        "max-tag-placeholder": item['max-tag-placeholder'],
        "placeholder": item.placeholder || '请选择'
      },
      on: {
        "on-change": function($event) {
          return _vm.selectorChanged(item, $event)
        }
      }
    }, [_vm._l((Object.keys(item.loader ? item.loader() : item.selections)), function(group) {
      return (item.group) ? _c('OptionGroup', {
        key: group,
        attrs: {
          "label": group
        }
      }, _vm._l((item.loader ? item.loader() : item.selections[group]), function(selection, selectionindex) {
        return _c('Option', {
          key: selectionindex,
          attrs: {
            "value": item.render(selection)
          }
        }, [_vm._v(_vm._s(item.render(selection)))])
      }), 1) : _vm._e()
    }), _vm._v(" "), _vm._l((item.loader ? item.loader() : item.selections), function(selection, selectionindex) {
      return (!item.group) ? _c('Option', {
        key: selectionindex,
        attrs: {
          "value": item.render(selection)
        }
      }, [_vm._v(_vm._s(item.render(selection)))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.type == 'daterange') ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [(item.riqitypes) ? _c('Select', {
      staticStyle: {
        "width": "100px",
        "margin-right": "10px"
      },
      on: {
        "on-change": function($event) {
          return _vm.riqitypeChanged(item, $event);
        }
      },
      model: {
        value: (_vm.query.riqitype),
        callback: function($$v) {
          _vm.$set(_vm.query, "riqitype", $$v)
        },
        expression: "query.riqitype"
      }
    }, _vm._l((item.riqitypes), function(riqitype) {
      return _c('Option', {
        key: riqitype,
        attrs: {
          "value": riqitype
        }
      }, [_vm._v(_vm._s(riqitype))])
    }), 1) : _vm._e(), _vm._v(" "), _c('DatePicker', {
      style: (("width:" + (item.width || 432) + "px")),
      attrs: {
        "value": _vm.query.riqi,
        "format": "yyyy-MM-dd",
        "type": "daterange",
        "placement": "bottom-end",
        "placeholder": item.label || '选择日期范围',
        "clearable": item.clearable || false
      },
      on: {
        "on-change": function($event) {
          return _vm.daterangeChanged(item, $event)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type == 'text') ? _c('div', [(!_vm.query[item.key]) ? _c('Input', {
      ref: 'input:' + item.key,
      refInFor: true,
      style: (("width:" + (item.width || 240) + "px")),
      attrs: {
        "icon": "ios-search",
        "placeholder": item.placeholder || ''
      },
      on: {
        "on-enter": function($event) {
          return _vm.textChanged(item)
        }
      },
      model: {
        value: (_vm.inputing[item.key]),
        callback: function($$v) {
          _vm.$set(_vm.inputing, item.key, $$v)
        },
        expression: "inputing[item.key]"
      }
    }) : _vm._e(), _vm._v(" "), ((!!_vm.query[item.key])) ? _c('div', {
      staticClass: "jcsb nowrap",
      style: (("height: 32px;line-height: 32px;margin: 0;width: " + (item.width || 240) + "px;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;")),
      on: {
        "click": function($event) {
          return _vm.textEdit(item)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.query[item.key]))]), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-close-circle"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.textClear(item)
        }
      }
    })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type == 'numberrange') ? _c('div', [((!!_vm.query[item.key] && (_vm.query[item.key][0] || _vm.query[item.key][1]))) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.numberrangeEdit(item)
        }
      }
    }, [(item.label) ? _c('div', {
      style: (("height: 32px;line-height: 32px;margin: 0;width: " + (item.width || 320) + "px;background-color:#f5f5f5;color:#aaa;padding: 0 8px;border-radius: 4px;"))
    }, [_c('div', {
      staticClass: "jcsb"
    }, [_c('div', {
      staticClass: "df"
    }, [_c('div', {
      style: (("width:" + ((item.label.length+1) * 16) + "px;color:#aaa"))
    }, [_vm._v(_vm._s(item.label) + "：")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "80px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.query[item.key][0] ? _vm.query[item.key][0] : '0'))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "0 10px"
      }
    }, [_vm._v("~")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "80px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.query[item.key][1] ? _vm.query[item.key][1] : '∞'))])]), _vm._v(" "), _c('Icon', {
      staticStyle: {
        "color": "#999"
      },
      attrs: {
        "type": "ios-close-circle"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.numberrangeClear(item)
        }
      }
    })], 1)]) : _c('div', [_vm._v("label required")])]) : _c('div', [(item.label) ? _c('div', {
      style: (("height: 32px;line-height: 32px;margin: 0;width: " + (item.width || 320) + "px;border:1px solid #ddd;padding: 0 8px;border-radius: 4px;"))
    }, [_c('div', {
      staticClass: "jcsb"
    }, [_c('div', {
      staticClass: "df"
    }, [_c('div', {
      style: (("width:" + ((item.label.length+1) * 16) + "px;color:#aaa"))
    }, [_vm._v(_vm._s(item.label) + "：")]), _vm._v(" "), _c('Input', {
      ref: 'input:' + item.key + '_min',
      refInFor: true,
      staticStyle: {
        "width": "80px",
        "text-align": "center",
        "background-color": "#f1f1f1"
      },
      attrs: {
        "size": "small",
        "placeholder": "最小值",
        "border": false
      },
      on: {
        "on-enter": function($event) {
          return _vm.numberrangeChanged(item)
        }
      },
      model: {
        value: (_vm.inputing[((item.key) + "_min")]),
        callback: function($$v) {
          _vm.$set(_vm.inputing, ((item.key) + "_min"), _vm._n($$v))
        },
        expression: "inputing[`${item.key}_min`]"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "0 10px"
      }
    }, [_vm._v("~")]), _vm._v(" "), _c('Input', {
      ref: 'input:' + item.key + '_max',
      refInFor: true,
      staticStyle: {
        "width": "80px",
        "text-align": "center",
        "background-color": "#f1f1f1"
      },
      attrs: {
        "size": "small",
        "placeholder": "最大值",
        "border": false
      },
      on: {
        "on-enter": function($event) {
          return _vm.numberrangeChanged(item)
        }
      },
      model: {
        value: (_vm.inputing[((item.key) + "_max")]),
        callback: function($$v) {
          _vm.$set(_vm.inputing, ((item.key) + "_max"), _vm._n($$v))
        },
        expression: "inputing[`${item.key}_max`]"
      }
    })], 1), _vm._v(" "), _c('Icon', {
      staticStyle: {
        "color": "#999"
      },
      attrs: {
        "type": "ios-search"
      }
    })], 1)]) : _c('div', [_vm._v("label required")])])]) : _vm._e(), _vm._v(" "), (item.type == 'jigou' || item.type == 'gonghuojigou') ? _c('BaseSelect', {
      attrs: {
        "value": _vm.query[item.key],
        "multiple": item.multi,
        "type": item.type,
        "parameter": item.query,
        "placeholder": item.placeholder
      },
      on: {
        "change": function($event) {
          return _vm.jigouChanged(item, $event)
        }
      }
    }) : _vm._e()], 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.options.confirm) ? _c('div', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doQuery
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.init
    }
  }, [_vm._v("重置条件")])], 1) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f26b64d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f26b64d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Query.vue
// module id = 60Ea
// module chunks = 142